'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var ipfsUnixfsExporter = require('ipfs-unixfs-exporter');

var debug = require('debug');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = debug__default["default"]('ipfs:mfs:utils:to-trail');

function toTrail(_x, _x2) {
  return _toTrail.apply(this, arguments);
}

function _toTrail() {
  _toTrail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, path) {
    var output, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, fsEntry;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            log("Creating trail for path ".concat(path));
            output = [];
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 4;
            _iterator = _asyncIterator(ipfsUnixfsExporter.walkPath(path, context.repo.blocks));

          case 6:
            _context.next = 8;
            return _iterator.next();

          case 8:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 14;
              break;
            }

            fsEntry = _step.value;
            output.push({
              name: fsEntry.name,
              cid: fsEntry.cid,
              size: fsEntry.size,
              type: fsEntry.type
            });

          case 11:
            _iteratorAbruptCompletion = false;
            _context.next = 6;
            break;

          case 14:
            _context.next = 20;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 20:
            _context.prev = 20;
            _context.prev = 21;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 25;
              break;
            }

            _context.next = 25;
            return _iterator.return();

          case 25:
            _context.prev = 25;

            if (!_didIteratorError) {
              _context.next = 28;
              break;
            }

            throw _iteratorError;

          case 28:
            return _context.finish(25);

          case 29:
            return _context.finish(20);

          case 30:
            return _context.abrupt("return", output);

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 16, 20, 30], [21,, 25, 29]]);
  }));
  return _toTrail.apply(this, arguments);
}

exports.toTrail = toTrail;